import moment from 'moment';

export const formatSessionLabel = (
  sessionDateTime: string,
  sessionDurationInMinutes: number,
) => {
  const momentStartDate = moment(sessionDateTime);

  const formattedDate = momentStartDate.format('MMMM Do');
  const formattedStartTime =
    momentStartDate.minute() === 0
      ? momentStartDate.format('h A')
      : momentStartDate.format('h:mm A');

  const momentEndDate = momentStartDate.add(
    sessionDurationInMinutes,
    'minutes',
  );
  const formattedEndTime =
    momentEndDate.minute() === 0
      ? momentEndDate.format('h A')
      : momentEndDate.format('h:mm A');

  return `${formattedDate}, ${formattedStartTime} - ${formattedEndTime}`;
};
